import { BaseService } from './../base'
export class SexService extends BaseService {
    static get entity () {
        return 'sex'
    }
    static get name () {
        return 'sex'
    }
}